module.exports = __webpack_public_path__ + "static/media/contract-step1.dd50104e.png";